/**
 * Box partagées avec l'éditeur de site qui portent PLUSIEURS textes riches au
 * lieu d'un seul.
 *
 * Chaque clé `k` d'un type vit en `content.<k>EditorState` dans le store du
 * document et se sérialise en `content.<k>Raw`, comme `content.editorState` /
 * `content.raw` pour une box texte ordinaire.
 *
 * Une seule liste, lue par la sérialisation (`utils/dataSync`), le chargement
 * et le parser : y ajouter un texte suffit à le faire vivre partout.
 *
 * Les types sont écrits en clair, pas via `ItemTypes` : `constants.js` importe
 * déjà ce dossier pour ses valeurs par défaut, l'inverse serait circulaire.
 */
export const MULTI_TEXT_CONTENT_KEYS = {
  accordion_panel: ['question', 'answer'],
  // `title` et non `value` : le bloc web garde le nom historique de sa prop,
  // le document appelle le texte par ce qu'il est (cf. infoCardFromBox).
  info_card: ['title', 'description'],
};

export const isAMultiTextBox = (type) => !!MULTI_TEXT_CONTENT_KEYS[type];
